import widgetConfig from './index';
import style from './../../component/common/style/index.scss';

let performanceByQuestionConfig = {
    tableColumnDefinition: [
      {
        headerName: "Question",
        field: "name",
        sortable: true,
        minWidth: 200,
        unSortIcon: true,
        sortingOrder: ['asc'],
        cellClass: [style.fontCls].join(' ')
      }
      , {
        headerName: "Group average %",
        field: "percentage",
        sortable: true,
        minWidth: 150,
        unSortIcon: true,
        sortingOrder: ['asc'],
        cellClass: [style.centerCls, style.fontCls].join(' ')
      }
      , {
        headerName: "Question description",
        field: "description",
        minWidth: 570,
        wrapText:true,
        autoHeight:true,
        sortable: true,
        unSortIcon: true,
        sortingOrder: ['asc'],
        cellClass: [style.fontCls, style.leftAlignCls].join(' '),
        cellRenderer: (params) => {
          return params.value;
        }
      }
     
    ],
 
}

export default performanceByQuestionConfig;